/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TelephoneParcDto } from '../models/telephone-parc-dto';


/**
 * Fonctions de gestion des téléphones des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class TelephonesRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation telephoneParcGetList
   */
  static readonly TelephoneParcGetListPath = '/api/telephones-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des téléphones du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<TelephoneParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TelephoneParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des téléphones du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<TelephoneParcDto>> {

    return this.telephoneParcGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TelephoneParcDto>>) => r.body as Array<TelephoneParcDto>)
    );
  }

  /**
   * Path part for operation telephoneParcLoadList
   */
  static readonly TelephoneParcLoadListPath = '/api/telephones-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des téléphones du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des téléphones du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.telephoneParcLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation telephoneParcGet
   */
  static readonly TelephoneParcGetPath = '/api/telephones-recyparcs/{id}';

  /**
   * Renvoie le téléphone spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcGet$Response(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;
  }): Observable<StrictHttpResponse<TelephoneParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TelephoneParcDto>;
      })
    );
  }

  /**
   * Renvoie le téléphone spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcGet(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;
  }): Observable<TelephoneParcDto> {

    return this.telephoneParcGet$Response(params).pipe(
      map((r: StrictHttpResponse<TelephoneParcDto>) => r.body as TelephoneParcDto)
    );
  }

  /**
   * Path part for operation telephoneParcPut
   */
  static readonly TelephoneParcPutPath = '/api/telephones-recyparcs/{id}';

  /**
   * Met à jour le téléphone spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcPut$Response(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;

    /**
     * Téléphone
     */
    body: TelephoneParcDto
  }): Observable<StrictHttpResponse<TelephoneParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TelephoneParcDto>;
      })
    );
  }

  /**
   * Met à jour le téléphone spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcPut(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;

    /**
     * Téléphone
     */
    body: TelephoneParcDto
  }): Observable<TelephoneParcDto> {

    return this.telephoneParcPut$Response(params).pipe(
      map((r: StrictHttpResponse<TelephoneParcDto>) => r.body as TelephoneParcDto)
    );
  }

  /**
   * Path part for operation telephoneParcDelete
   */
  static readonly TelephoneParcDeletePath = '/api/telephones-recyparcs/{id}';

  /**
   * Supprime le téléphone spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcDelete$Response(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le téléphone spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  telephoneParcDelete(params: {

    /**
     * Identifiant du téléphone
     */
    id: number;
  }): Observable<number> {

    return this.telephoneParcDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation telephoneParcPost
   */
  static readonly TelephoneParcPostPath = '/api/telephones-recyparcs/{parcId}';

  /**
   * Crée un téléphone pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telephoneParcPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcPost$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Téléphone
     */
    body: TelephoneParcDto
  }): Observable<StrictHttpResponse<TelephoneParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TelephonesRecyparcsService.TelephoneParcPostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TelephoneParcDto>;
      })
    );
  }

  /**
   * Crée un téléphone pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telephoneParcPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  telephoneParcPost(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Téléphone
     */
    body: TelephoneParcDto
  }): Observable<TelephoneParcDto> {

    return this.telephoneParcPost$Response(params).pipe(
      map((r: StrictHttpResponse<TelephoneParcDto>) => r.body as TelephoneParcDto)
    );
  }

}
